import { message } from './message'

/**
 * Copies `text` to the clipboard and toasts the outcome, resolving to whether it worked —
 * so a caller that closes its modal afterwards can stay open when the copy failed.
 *
 * **Await it.** Copying rejects on a denied permission or an insecure context, and both the
 * failure toast and the `false` depend on the rejection being caught here.
 */
export async function copyToClipboard(
  text: string,
  options: { success?: string } = {}
): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text)
    message.success(options.success ?? 'Copied!')
    return true
  } catch {
    message.error('Copy failed')
    return false
  }
}
